export const TREE_VIEW_DEFAULT_WIDTH = 400;
export const TREE_VIEW_DEFAULT_WIDTH_DIALOG_MODE = 300;

export const ALL_MODULES_TREE_ITEM_ID = 'all-modules';
